import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { useAuthState } from '@creditornot/wolt-auth/react';
import { UseQueryConfig } from 'common/query/types';

import { gatewayApiAgent } from '../api/apiAgents';
import { WarehousesListPage } from '../api-types/director';
import { FetchListItemsParams } from '../types';

type FetchWarehousesParams = FetchListItemsParams & { franchise?: string };

const WAREHOUSES_QUERY_KEY_ROOT = 'warehouses';

const pageDefaults = { pageSize: 1000, page: 0 };

const fetchWarehouses = (params?: FetchWarehousesParams): Promise<WarehousesListPage> =>
  gatewayApiAgent
    .get('/director/public/v1/warehouses', { params: { ...pageDefaults, ...params } })
    .then((res) => res.data);

export const useWarehousesQuery = (
  params: FetchWarehousesParams = {},
  options?: UseQueryConfig<WarehousesListPage, Error>,
) => {
  const { status } = useAuthState();

  return useQuery({
    staleTime: 300000,
    enabled: status === 'logged-in',
    placeholderData: (previousData) => previousData,
    ...options,
    queryKey: [WAREHOUSES_QUERY_KEY_ROOT, params],
    queryFn: () => fetchWarehouses(params),
  });
};

export const useAllWarehousesSuspenseQuery = () => {
  return useSuspenseQuery({
    staleTime: 300000,
    queryKey: ['allWarehouses'],
    queryFn: () => fetchWarehouses(),
  });
};
